import { useEffect } from "react";

import { useSessionStorage } from "usehooks-ts";

import { useAnalytics } from "./AnalyticsProvider";

export function LogOutTracker() {
  const { trackEvent, reset } = useAnalytics();
  const [hadSession, setHadSession] = useSessionStorage("hadSession", false);

  useEffect(() => {
    if (hadSession) {
      trackEvent("logged_out");
      reset();
      setHadSession(false);
      sessionStorage.removeItem("currentBotSession");
      sessionStorage.removeItem("hasLoggedInThisSession");
    }
  }, [hadSession, reset, setHadSession, trackEvent]);

  return null;
}
